/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader';
import { PanelStyle } from '../../constants';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import s from './EServices.css';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import _ from 'lodash';
import fetch from '../../core/fetch';

import v from './validators';

const {
  errorSpanStyle,
} = PanelStyle;


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const AddressFormDict = {
  AddressCity: {
    label: 'Miejscowość',
    editable: true,
  },
  AddressStreet: {
    label: 'Ulica',
    editable: true,
  },
  AddressNumber: {
    label: 'Numer budynku',
    editable: true,
  },
  AddressFlat: {
    label: 'Numer lokalu',
    editable: true,
    type: "number",
  },
};

const LandDevelDict = {
  LocalColor: {
    label: 'Kolor oznaczenia lokalizacji',
    editable: true,
  },
  LineColor: {
    label: 'Kolor inwestycji liniowych',
    editable: true,
  },
  BoundColor: {
    label: 'Kolor granicy terenu inwestycji',
    editable: true,
  },
  PolygonColor: {
    label: 'Kolor obszaru oddziaływania inwestycji',
    editable: true,
  }
};

const LinearDict = {
  OccupationWidth: {
    label: 'Szerokość zajętego pasa',
    editable: true,
    type: "number",
  },
  OccupationArea: {
    label: 'Powierzchnia zajęta',
    editable: true,
    type: "number",
  },
};

const IntendedBuildTypeDict = {
  BuildTypeName: {
    label: 'Inwestycja polegająca na:',
    editable: true,
  },
  InvestDestination: {
    label: 'Inwestycja celu publicznego o znaczeniu (krajowe i wojewódzkie lub powiatowe i gminne): ',
    editable: true,
  },
};

const QualificationDict = {
  InvestArt: {
    label: 'Artykuł',
    editable: true,
  },
  InvestLaw: {
    label: 'Ustawy',
    editable: true,
  },
};

const PlannedBuildCharacteristics = {
  BuildArea: {
    label: 'Powierzchnia zabudowy budynku [m2]',
    editable: true,
    type: "number",
  },
  BuildBiolArea: {
    label: 'Powierzchnia biologicznie czynna [m2]',
    editable: true,
    type: "number",
  },
  MaxHeight: {
    label: 'Maksymalna wysokość [m]',
    editable: true,
    type: "number",
  },
  OvergroundStoreys: {
    label: 'Liczba kondygnacji nadziemnych',
    editable: true,
    type: "number",
  },
  UndergroundStoreys: {
    label: 'Liczba kondygnacji podziemnych',
    editable: true,
    type: "number",
  },
  TotalArea: {
    label: 'Powierzchnia całkowita łącznie',
    editable: true,
    type: "number",
  },
  UsableArea: {
    label: 'Powierzchnia użytkowa łącznie',
    editable: true,
    type: "number",
  },
};

const InfrastructureNeeds = {
  Water: { label: 'Woda: ', editable: true },
  Energy: { label: 'Energia elektryczna: ', editable: true },
  Gas: { label: 'Gaz: ', editable: true },
  Sewege: { label: 'Odprowadzanie i oczyszczenie ścieków', editable: true },
  Heat: {
    label: 'Sposób ogrzewania obiektów kubaturowych (podać rodzaj czynnika grzewczego)',
    editable: true,
  },
  Other: { label: 'Inne potrzeby', editable: true },
};

const OtherInfo = {
  ParkingCount: {
    label: 'Przewidywana liczba miejsc parkingowych: ',
    editable: true,
    type: "number",
  },
  ParkingArea: {
    label: 'Przewidywana powierzchnia dróg i parkingów: ',
    editable: true,
    type: "number",
  },
  ParkingBiolArea: {
    label: 'Przewidywana powierzchnia biologicznie czynna: ',
    editable: true,
    type: "number",
  },
};

const InvestAreaInfo = {
  InvestArea: {
    label:
      'Powierzchnia terenu inwestycji: ',
    editable: true,
  },
  InvestAreaTransform: {
    label:
      'Powierzchnia terenu podlegająca przekształceniu: ',
    editable: true,
  },
  InvestGreenery: {
    label:
      'Występowanie zieleni wysokiej i średniej (w szczególności przewidzianych przez inwestora drzew do wycinki lub przesadzenia)',
    editable: true,
  },
  InvestGroundNetwork: {
    label:
      'Występowanie sieci uzbrojenia (w szczególności przewidzianych przez inwestora do likwidacji lub przebudowy)',
    editable: true,
  },
  InvestBuildings: {
    label:
      'Występowanie budynków, budowli usytuowanych na terenie inwestycji (w szczególności przewidzianych przez inwestora do rozbiórki lub przebudowy)',
    editable: true,
  },
  CurrentInvestAreaUse: {
    label: 'Obecne wykorzystanie terenu inwestycji i budynków na nim się znajdujących',
    editable: true,
  },
  EnvironDescription: {
    label: 'Opis otoczenia terenu:',
    editable: true,
    type: 'textarea',
  },
};

class DecyzjeULICP extends React.Component {
  state = {
    DecisionData: {
      AddressCity: null,
      AddressStreet: null,
      AddressFlat: null,
      AddressNumber: null,
      AddressZipCode: null,
    },
    BuildType: {
      BuildTypeName: null,
      InvestDestination: null,
      InvestArt: null,
      InvestLaw: null,
    },
    LandDevelop: {
      LocalColor: null,
      LineColor: null,
      BoundColor: null,
      PolygonColor: null,
      OccupationWidth: null,
      OccupationArea: null,
    },
    BuildCharacteristics: {
      BuildDescription: null,
    },
    PlannedBuildCharacteristics: {
      BuildArea: null,
      BuildBiolArea: null,
      MaxHeight: null,
      OvergroundStoreys: null,
      UndergroundStoreys: null,
      TotalArea: null,
      UsableArea: null,
    },
    OtherBuildCharacteristics: {
      OtherParams: null,
    },
    InfrastructureNeeds: {
      Water: null,
      Energy: null,
      Gas: null,
      Sewege: null,
      Heat: null,
      Other: null,
    },
    OtherInfo: {
      ParkingCount: null,
      ParkingArea: null,
      ParkingBiolArea: null,
    },
    InvestAreaInfo: {
      InvestArea: null,
      InvestAreaTransform: null,
      InvestGreenery: null,
      InvestGroundNetwork: null,
      InvestBuildings: null,
      CurrentInvestAreaUse: null,
      EnvironDescription: null,
    },
    OwnershipInfo: {
      InvestOwnership: null,
      ParcelOwnership: null,
    },
    RoadInfo: {
      AccessToArea: null,
      ExitToPublicRoad: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null
  };

  elseString = '.....................';
  spanStyle = {
    color: 'red',
  };

  validators = {
    AddressCity: [v.NotNull, v.MinLength(2)],
    AddressStreet: [v.NotNull],
    AddressFlat: [v.NotNull],
    AddressNumber: [v.NotNull],
    BuildTypeName: [v.NotNull],
    InvestDestination: [v.NotNull],
    InvestArt: [v.NotNull],
    InvestLaw: [v.NotNull],
    LocalColor: [v.NotNull],
    LineColor: [v.NotNull],
    OccupationWidth: [v.NotNull],
    OccupationArea: [v.NotNull],
    BuildArea: [v.NotNull],
    BuildBiolArea: [v.NotNull],
    MaxHeight: [v.NotNull],
    OvergroundStoreys: [v.NotNull],
    UndergroundStoreys: [v.NotNull],
    TotalArea: [v.NotNull],
    UsableArea: [v.NotNull],
    OtherParams: [v.NotNull],
    Water: [v.NotNull],
    Energy: [v.NotNull],
    Gas: [v.NotNull],
    Sewege: [v.NotNull],
    Heat: [v.NotNull],
    Other: [v.NotNull],
    ParkingCount: [v.NotNull],
    ParkingArea: [v.NotNull],
    ParkingBiolArea: [v.NotNull],
    InvestArea: [v.NotNull],
    InvestAreaTransform: [v.NotNull],
    InvestGreenery: [v.NotNull],
    InvestGroundNetwork: [v.NotNull],
    InvestBuildings: [v.NotNull],
    CurrentInvestAreaUse: [v.NotNull],
    EnvironDescription: [v.NotNull],
    InvestOwnership: [v.NotNull],
    ParcelOwnership: [v.NotNull],
    AccessToArea: [v.NotNull],
    ExitToPublicRoad: [v.NotNull],
    BuildDescription: [v.NotNull],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentWillMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp
        })
      })
  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });
  setRoads = (roads, callback = null) => this.setState({ selectedRoads: roads });

  render_info = (group, key) => (
    <span>
      <b>{this.state[group][key] ? this.state[group][key] : this.elseString}</b>
    </span>
  );

  getLandDevelExplain = () => (
    <p style={{ textAlign: 'justify' }}>
      Planowana lokalizacja projektowanego zamierzenia została oznaczona na załączonej do wniosku
      kopii mapy zasadniczej (jednym egzemplarzu) linią koloru:<br />
      {' '} {this.render_info('LandDevelop', 'LocalColor')}. <br />
      <br />
      Przewidywany przebieg projektowanych inwestycji liniowych (sieci uzbrojenia, drogi) oznaczono na
      mapie zasadniczej linią koloru:<br />
      {' '} {this.render_info('LandDevelop', 'LineColor')}.<br />
      <br />
      Granice terenu inwestycji oznaczono na mapie linią koloru:<br />
      {' '} {this.render_info('LandDevelop', 'BoundColor')}.<br />
      <br />
      Obszar na który inwestycja będzie oddziaływać oznaczono na mapie linią koloru:<br />
      {' '} {this.render_info('LandDevelop', 'PolygonColor')}.<br />
      <br />
    </p>
  );

  getLinearExplain = () => (
    <p style={{ textAlign: 'justify' }}>
      W przypadku realizacji inwestycji liniowej podać przewidywaną do czasowego zajęcia szerokości pasa
      terenu wzdłuż projektowanej sieci: {' '} {this.render_info('LandDevelop', 'OccupationWidth')}, ewentualnie
      wielkość terenu niezbędnego dla zajęcia pod budynki tymczasowe (np. pas terenu dla ruchu ciężkich samochodów i maszyn
      budowlanych, place dla składowania materiałów i lokalizację barakowozów):
      {this.render_info('LandDevelop', 'OccupationArea')} m<sup>2</sup>.
    </p>
  )

  getQualification = () => (
    <p style={{ textAlign: 'justify' }}>
      Inwestycja została zakwalifikowana jako inwestycja celu publicznego oparciu o
    </p>
  )

  getIntendedBuildTypeExplain = () => (
    <p style={{ textAlign: 'justify' }}>
      tj. rodzaj planowanych robót budowlanych (np. budowa/wykonanie a także odbudowa, rozbudowa,
      nadbudowa, obiektu budowlanego/, lub prace polegające na przebudowie , montażu, remoncie lub
      rozbiórce obiektu budowlanego oraz zmiana sposobu użytkowania obiektu budowlanego lub jego
      części) oraz funkcja i sposób zagospodarowania terenu inwestycji (np. budynek: mieszkalny,
      jednorodzinny, wielorodzinny, usługowy, handlowy, gospodarczy, garaż):
    </p>
  );

  getInputWithError = (description, group, field) => (
    <div style={{ textAlign: 'justify' }}>
      {description}
      <input
        className="form-control"
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(field) > -1 &&
              this.state.errors[field] !== null &&
              this.state.errors[field].length > 0
              ? 'red'
              : '#ccc',
        }}
        value={this.state[group][field] ? this.state[group][field] : ''}
        onChange={e => this.onChange(e, group)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(field) > -1 &&
        this.state.errors[field] !== null &&
        this.state.errors[field].length > 0
        ? this.state.errors[field].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </div>
  )

  getTextAreaWithError = (description, group, field) => (
    <p style={{ textAlign: 'justify' }}>
      {description}
      <textarea
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(field) > -1 &&
              this.state.errors[field] !== null &&
              this.state.errors[field].length > 0
              ? 'red'
              : '#ccc',
        }}
        className="form-control"
        rows={10}
        value={this.state[group][field] ? this.state[group][field] : ''}
        onChange={e => this.onChange(e, group)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(field) > -1 &&
        this.state.errors[field] !== null &&
        this.state.errors[field].length > 0
        ? this.state.errors[field].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </p>
  )

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ["DecisionData", "BuildType", "LandDevelop",
        "PlannedBuildCharacteristics", "OtherBuildCharacteristics",
        "InfrastructureNeeds", "OtherInfo", "InvestAreaInfo",
        "OwnershipInfo",
        "RoadInfo"];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      DecisionData: {
        AddressCity: 'Warszawa',
        AddressStreet: 'Koncertowa',
        AddressFlat: 9,
        AddressNumber: 6,
      },
      BuildType: {
        BuildTypeName: 'testowy',
        InvestDestination: 'testowy',
        InvestArt: 'testowy artykuł',
        InvestLaw: 'testowa ustawa',
      },
      LandDevelop: {
        LocalColor: "red",
        LineColor: "Blue",
        OccupationWidth: 123.12,
        OccupationArea: 123.32,
      },
      BuildCharacteristics: {
        BuildDescription: "hhhhhhhhhhhhhhhhaahahah to jet opis",
      },
      PlannedBuildCharacteristics: {
        BuildArea: 15.35,
        BuildBiolArea: 15.33,
        MaxHeight: 153.11,
        OvergroundStoreys: 2,
        UndergroundStoreys: 2,
        TotalArea: 133.33,
        UsableArea: 133.33,
      },
      OtherBuildCharacteristics: {
        OtherParams: "to powinien być text",
      },
      InfrastructureNeeds: {
        Water: "jest",
        Energy: "bendzie",
        Gas: "wewe",
        Sewege: "jesttt",
        Heat: "ni ma",
        Other: "asdfsdf",
      },
      OtherInfo: {
        ParkingCount: 1,
        ParkingArea: 21.35,
        ParkingBiolArea: 35.3333,
      },
      InvestAreaInfo: {
        InvestArea: "teeeeeeeeeeeeeees",
        InvestAreaTransform: "teeeeeeeeeeeeeees",
        InvestGreenery: "teeeeeeeeeeeeeees",
        InvestGroundNetwork: "teeeeeeeeeeeeeees",
        InvestBuildings: "teeeeeeeeeeeeeees",
        CurrentInvestAreaUse: "teeeeeeeeeeeeeees",
        EnvironDescription: "teeeeeeeeeeeeeees",
      },
      OwnershipInfo: {
        InvestOwnership: "Krzysztof Gregorowicz",
        ParcelOwnership: "Krzysztof Gregorowicz",
      },
      RoadInfo: {
        AccessToArea: "Działka znajduje się prz drodze publicznej",
        ExitToPublicRoad: "Tak",
      },
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
      return;
    }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true
      });
      return;
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          DecisionData: { ...this.state.DecisionData },
          BuildType: { ...this.state.BuildType },
          LandDevelop: { ...this.state.LandDevelop },
          BuildCharacteristics: { ...this.state.BuildCharacteristics },
          PlannedBuildCharacteristics: { ...this.state.PlannedBuildCharacteristics },
          OtherBuildCharacteristics: { ...this.state.OtherBuildCharacteristics },
          InfrastructureNeeds: { ...this.state.InfrastructureNeeds },
          OtherInfo: { ...this.state.OtherInfo },
          InvestAreaInfo: { ...this.state.InvestAreaInfo },
          OwnershipInfo: { ...this.state.OwnershipInfo },
          RoadInfo: { ...this.state.RoadInfo },
          selectedParcels: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          urzad: this.props.districts[this.props.prefix]
        })
        .then(resp => {
          window.location.href = `${this.nextStep}${resp.jobId}`;
        });
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {

    return (
      <div style={{ paddingTop: '20px' }}>
        {this.props.district === "205011" ?
          <h4 style={{ textAlign: 'justify', color: 'red', marginLeft: '15px', marginRight: '15px' }}>
            Uwaga! Ze względu na pełne pokrycie gminy miejscowymi planami
            zagospodarowania przestrzennego informujemy, że Urząd nie rozpatruje
            wniosków ws. wydania decyzji o warunkach zabudowy oraz wniosków ws.
            ustalenia lokalizacji inwestycji celu publicznego. Prosimy o składanie
            wniosków ws. wydania wypisu i wyrysu z miejscowego planu zagospodarowania
            przestrzennego.
        </h4> : null
        }
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <DecisionContainer
          title={'1. Adres'}
          data={this.state.DecisionData}
          errors={this.state.errors}
          formDict={AddressFormDict}
          onChange={e => this.onChange(e, 'DecisionData')}
        >
          <div className="help-desc">
            W celu wybrania przedmiotowej działki lub działek ewidencyjnych należy wykorzystać jeden z dwóch dostępnych sposobów wyboru działki:<br />
            <ol>
              <li> Wybrać obręb ewidencyjny z rozwijalnej listy obrębów, a następnie wpisać numer działki. W celu dodania kolejnej działki należy powtórzyć czynność.</li>
              <li>Wskazać działkę w oknie mapy wykorzystując przycisk <samp>"Wskaż działki na mapie"</samp>. W celu wybrania kilku działek konieczne jest przytrzymanie na klawiaturze klawisza <kbd>CTRL</kbd>.</li>
            </ol>
            Wybór działek można usunąć pojedynczo lub usuwając wszystkie za pomocą przycisku <samp>"Odznacz wszystko"</samp>.
          </div>
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </DecisionContainer>

        <DecisionContainer
          title={'2. Rodzaj zamierzenia inwestycyjnego'}
          data={this.state.BuildType}
          errors={this.state.errors}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          formDict={IntendedBuildTypeDict}
          onChange={e => this.onChange(e, 'BuildType')}
        />

        <DecisionContainer
          title={'3. Kwalifikacja inwestycji celu publicznego'}
          data={this.state.BuildType}
          errors={this.state.errors}
          explain_text={() => this.getQualification()}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          formDict={QualificationDict}
          onChange={e => this.onChange(e, 'BuildType')}
        />

        <DecisionContainer
          title={'4. Charakterystyka planowanej budowy'}
          data={this.state.LandDevelop}
          errors={this.state.errors}
          explain_text={() => this.getLandDevelExplain()}
          formDict={LandDevelDict}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'LandDevelop')}
        />

        <DecisionContainer
          title={'5. W przypadku inwestycji liniowej'}
          data={this.state.LandDevelop}
          errors={this.state.errors}
          explain_text={() => this.getLinearExplain()}
          formDict={LinearDict}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'LandDevelop')}
        />

        <GrayPanel title={'6. Ogólna charakterystyka zamierzenia inwestycyjnego: '}>
          {this.getTextAreaWithError(
            `Charakterystyka funkcji zabudowy i zagospodarowania terenu: `,
            "BuildCharacteristics",
            "BuildDescription"
          )}
        </GrayPanel>

        <DecisionContainer
          title={'7. Charakterystyka planowania zabudowy: '}
          data={this.state.PlannedBuildCharacteristics}
          errors={this.state.errors}
          formDict={PlannedBuildCharacteristics}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'PlannedBuildCharacteristics')}
        />

        <GrayPanel title={'8. Charakterystyczne parametry techniczne projektowanej inwestycji: '}>
          {this.getTextAreaWithError(
            `Informacje zawierające dane na temat charakterystycznych etapów realizacji
            planowanej inwestycji budowy, rodzaj technologii i procesów związanych z przewidywaną
            działalnością gospodarczą oraz w przypadku braku obowiązku przeprowadzania postępowania
            w sprawie oceny oddziaływania na środowisko, dane charakteryzujące jej wpływ na
            środowisko np. emisja pyłów, gazów, zapachów, hałasu oraz promieniowania:`,
            "OtherBuildCharacteristics",
            "OtherParams"
          )}
        </GrayPanel>

        <DecisionContainer
          title={'9. Potrzeby inwestycji w zakresie infrastruktury technicznej'}
          data={this.state.InfrastructureNeeds}
          errors={this.state.errors}
          formDict={InfrastructureNeeds}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'InfrastructureNeeds')}
        />

        <DecisionContainer
          title={'10. Inne istotne informacje na temat inwestycji'}
          data={this.state.OtherInfo}
          errors={this.state.errors}
          formDict={OtherInfo}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'OtherInfo')}
        />

        <DecisionContainer
          title={'11. Dane o terenie inwestycji'}
          data={this.state.InvestAreaInfo}
          errors={this.state.errors}
          formDict={InvestAreaInfo}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'InvestAreaInfo')}
        />

        <GrayPanel title={'12. Dane dotyczące własności:'}>
          {this.getTextAreaWithError(
            'Dane dotyczące własności terenu inwestycji:',
            'OwnershipInfo',
            'InvestOwnership'
          )
          }
          {this.getTextAreaWithError(
            'Dane dotyczące własności działek, na które inwestycja będzie oddziaływać na dzień składania wniosku: ',
            'OwnershipInfo',
            'ParcelOwnership'
          )
          }
        </GrayPanel>

        <GrayPanel title={'13. Określenie dostępu do drogi publicznej: '}>
          {this.getInputWithError(
            'tj. obsługa komunikacyjna-dojazd do terenu odbywał się będzie:',
            'RoadInfo',
            'AccessToArea'
          )
          }
          {this.getInputWithError(
            ', zjazd na drogę publiczną:',
            'RoadInfo',
            'ExitToPublicRoad'
          )
          }
        </GrayPanel>

        <GrayPanel title={'INFORMACJA DLA WNIOSKODAWCY'}>
          <p style={{ textAlign: 'justify' }}>
            Do wniosku o wydanie decyzji należy załączyć, w uzgodnieniu z organem właściwym do wydania decyzji:
          </p>
          <p style={{ textAlign: 'justify' }}>Mapa w rozumieniu art. 52 ust. 2 pkt 1 Ustawy o planowaniu i zagospodarowaniu przestrzennym, w skali 1:500 / 1:1000, z określeniem granic terenu objętego wnioskiem i obszaru, na który inwestycja będzie oddziaływać (1 egz. mapy bez naniesień); </p>
          <p style={{ textAlign: 'justify' }}>W przypadku inwestycji liniowych: Mapa w rozumieniu art. 52 ust. 2 pkt 1 Ustawy o planowaniu i zagospodarowaniu przestrzennym, w skali 1:500 / 1:1000 / 1:2000 z określeniem granic terenu objętego wnioskiem i obszaru, na który inwestycja będzie oddziaływać (1 egz. mapy bez naniesień); </p>
          <p style={{ textAlign: 'justify' }}>Określenie zamierzenia inwestycyjnego przedstawione w spójnej formie opisowej oraz graficznej (określenie planowanego sposobu zagospodarowania terenu oraz charakterystyki zabudowy i zagospodarowania terenu, w tym przeznaczenia i gabarytów projektowanych obiektów budowlanych oraz powierzchni terenu podlegającej przekształceniu); </p>
          <p style={{ textAlign: 'justify' }}><b>Uwaga:</b> mapy prosimy złożyć do formatu A4. </p>
          <p style={{ textAlign: 'justify' }}>Decyzja o środowiskowych uwarunkowaniach, wydawana na podstawie Ustawy z dnia 3 października 2008 r. o udostępnianiu informacji o środowisku i jego ochronie, udziale społeczeństwa w ochronie środowiska oraz ocenach oddziaływania na środowisko (Dz.U. z 2008 r. nr 199, poz. 1227, z późn. zm.) i Rozporządzenia Rady Ministrów z dnia 9 listopada 2010 r. w sprawie przedsięwzięć mogących znacząco oddziaływać na środowisko (Dz. U. z 2010 r. nr 213, poz. 1397 z późn. zm.) – w odniesieniu do przedsięwzięć mogących zawsze znacząco oddziaływać na środowisko oraz przedsięwzięć mogących potencjalnie znacząco oddziaływać na środowisko; </p>
          <p style={{ textAlign: 'justify' }}><b>Uwaga:</b>Decyzja o środowiskowych uwarunkowaniach wydawana jest na wniosek podmiotu planującego podjęcie realizacji przedsięwzięcia, przez organ wskazany w art. 75 ww. ustawy. Zgodnie z art. 72 ust. 1 pkt 3 i ust. 3 tej ustawy wydanie decyzji o środowiskowych uwarunkowaniach następuje przed uzyskaniem decyzji o ustaleniu lokalizacji inwestycji celu publicznego. Decyzję o środowiskowych uwarunkowaniach dołącza się do wniosku o wydanie decyzji o ustaleniu lokalizacji inwestycji celu publicznego. Złożenie wniosku o wydanie decyzji o ustaleniu lokalizacji inwestycji celu publicznego powinno nastąpić w terminie 4 lat od dnia, w którym decyzja o środowiskowych uwarunkowaniach stała się ostateczna. </p>
          <p style={{ textAlign: 'justify' }}>Pełnomocnictwo imienne wraz z dowodem uiszczenia opłaty skarbowej – w przypadku ustanowienia pełnomocnika. </p>
          <p style={{ textAlign: 'justify' }}><b>POUCZENIE:</b></p>
          <p style={{ textAlign: 'justify' }}>W razie stwierdzenia braków formalnych wniosku, organ I instancji wezwie wnioskodawcę w trybie art. 64 §2 k.p.a. do uzupełnienia braków w terminie 7 dni, pod rygorem pozostawienia wniosku bez rozpoznania.</p>
        </GrayPanel>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ progress: 0 }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

DecyzjeULICP.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.object,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(DecyzjeULICP),
);



// WEBPACK FOOTER //
// src/routes/eservices/DecyzjeULICP.js